
/**
 * @fileOverview mmmLinkCheck Module checks for External and Internal Links
 * Last Modified: 6/11/2014
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ExternalLinkCheck',['require','lib/Util','jquery'],function (require) {
        var Util = require('lib/Util');
        var $ = require('jquery');

        /**
         * This takes a list of links and check for the Internal and External Links
         *
         * @constructor
         */
        var mmmLinkCheck = function () {
            $debug('mmmLinkCheck loaded - use ?debug=mmmLinkCheck for messages');
            $debug('**** mmmLinkCheck Set Up Started **** ', 'mmmLinkCheck');
            $debug('Highlighting: yellow = same domain, red = external domain, blue = external domain, but on ignore list, purple = used override class, orange = fuze hosted file', 'mmmLinkCheck');
            this.init();
        };

        /**
         * Initializes the Module
         * Run
         *
         * @method init
         * @returns {mmmLinkCheck}
         * @private
         */
        mmmLinkCheck.prototype.init = function () {
            return this.setOptions()
                        .build()
                        .scanNewWindowLinks();
        };

        /**
         * Scans the page for any link with a class of js-dpl-newWindow
        */
        mmmLinkCheck.prototype.scanNewWindowLinks = function () {
            var self = this;
            $debug('Updating any links (<a> tag only) with class of js-dpl-newWindow to open in a new window', 'mmmLinkCheck');
            $('a.js-dpl-newWindow').attr('target', '_blank');
            $debug(' ... done with that activity', 'mmmLinkCheck');
            return this;
        };

        /**
         *
         * This takes in data options from the SETTINGS object and overwrites any default values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {mmmLinkCheck}
         * @private
         */
        mmmLinkCheck.prototype.setOptions = function () {
            var options = SETTINGS;

            var defaults = {
                ExternalLink: '_blank',
                SameLink: '_self'
            };
            this.settings = $.extend({}, defaults, options);
            $debug('Setting Main Options ', 'mmmLinkCheck');
            $debug('     Settings Object: ' + $printObj(options),'mmmLinkCheck');
            $debug('     Module Default Settings: ' + $printObj(defaults),'mmmLinkCheck');
            $debug('     New Combined Settings: ' + $printObj(this.settings),'mmmLinkCheck');

            return this;
        };
        
        /*
         * Performs a check on all the Anchor tag to look for the domain and if domain matches open links in same window
         * Should be running on all the <a> tags on the current page
         *
         * @method build
         * @returns {mmmLinkCheck}
         * @public
        */
        mmmLinkCheck.prototype.build = function () {
            var self = this,
                externalLink = self.settings.ExternalLink,  //_blank param from settings
                sameLink = self.settings.SameLink,          //_self param from settings
                domain = $getDomain(true),                  //get the domain
                url,                                        //placeholder for URL
                hostname,                                   //placeholder for hostname
                externalIgnoreList = [
                    '', //catches tel: mailto: etc...
                    'previewext.3m.com',
                    'fuzeauth.3m.com',
                    'solutionsstage.3m.com',
                    '3mfrance.fr',
                    'solutions.3m.com',
                    'www.3m.com'
                ],
                internalIgnoreList = [
                    '', //catches tel: mailto: etc...
                    'previewint.mmm.com',
                    
                    '3msourcestage.mmm.com',
                    '3msource.mmm.com'
                ],
                fuzeEnv = getFUZEEnvironment;

                //set any preventative things first!
            $debug('SETTING KNOWN OVERRIDES....', 'mmmLinkCheck');
            $('.MMM--locationsMenu li a').addClass('externalSameWdw');

            $debug('PAGE DOMAIN IS ' + domain, 'mmmLinkCheck');

            if(SETTINGS.openExternalLinks !== undefined){
                if(SETTINGS.openExternalLinks === true){
                    $debug('SETTINGS.openExternalLinks set to true... looping through all links on page', 'mmmLinkCheck');
                    //Loop through the <a> Link tags
                    $('a').each(function(e){
                        var url = $(this).attr('href'), //current URL
                            //hostname = $getDomain(true, ($(this).prop('href', url).prop('hostname')).toLowerCase()),  //current hostname
                            $this = $(this);

                        if(!url) {
                            hostname = domain;
                        } else {
                            var regex = /.*\:\/\/([^\/]*).*/,
                                match = url.match(regex);
                            if(typeof match != 'undefined' && null != match) {
                                hostname = match[1];
                                hostname = $getDomain(true, hostname.toLowerCase());
                            } else {
                                hostname = domain;
                            }
                        }
                        
                        if ($(this).hasClass('externalSameWdw') === true){
                            $this.prop('target', sameLink);
                            self.highlight($this, 'purple');
                        }
                        //If hostnames does not match page domain
                        else if (hostname !== domain){
                            //no match, test our ignore list... to-do
                            if (fuzeEnv === 'MMM-int'){
                                //test against internal
                                if ($.inArray(hostname, internalIgnoreList) !== -1){
                                    $this.prop('target', sameLink);
                                    self.highlight($this, 'blue');
                                }
                                else {
                                    $this.prop('target', externalLink);
                                    self.highlight($this, 'red');
                                }
                            }
                            else {
                                //test against external
                                if ($.inArray(hostname, externalIgnoreList) !== -1){
                                    $this.prop('target', sameLink);
                                    self.highlight($this, 'blue');
                                }
                                else {
                                    $this.prop('target', externalLink);
                                    self.highlight($this, 'red');
                                }
                            }
                        }
                        else {
                            $this.prop('target', sameLink);
                            self.highlight($this, 'yellow');

                            //check to see if File download url exist by searching for 'myconnect'
                            if (this.href.indexOf('myconnect') !== -1){
                                $(this).prop('target', externalLink);
                                self.highlight($(this), 'orange');
                            }
                            //check to see if File download url exist by searching for 'myconnect'
                            if (this.href.indexOf('multimedia') !== -1 || this.href.indexOf('gpimmediacollections') !== -1){
                                $(this).prop('target', externalLink);
                                self.highlight($(this), 'orange');
                            }

                        }
                    });
                }
                else {
                    $debug('SETTINGS.openExternalLinks set, but equals: ' + SETTINGS.openExternalLinks, 'mmmLinkCheck');
                }
            }
            else {
                $debug('SETTINGS.openExternalLinks not set!', 'mmmLinkCheck');
            }
            return this;
        };

        /*
         * Highlights the links if debug mode is turned on...
         *
         * @method build
         * @returns {mmmLinkCheck}
         * @public
        */
        mmmLinkCheck.prototype.highlight = function ($el,color) {
            if (urlHash['debug'] === 'mmmLinkCheck'){
                color = '2px solid ' + color;
                $el.css('border', color);
            }
        };

        return mmmLinkCheck;
    });

}(MMMRequire));

    